import React from 'react';
import {BackgroundBlocker} from "../../../core/components/misc/blockers/background-blocker";
import {LANGUAGE_MENU} from "../language-menu-module.consts";

export const LanguageMenuModuleBackgroundBlocker = ({controller}) => {
  const {state} = controller;
  const {isMenuOpen, menuModel} = state;
  const {shouldCollapsedOnBgClick} = menuModel;

  const backgroundBlockerProps = {
    onDisable: () => shouldCollapsedOnBgClick && controller.action(LANGUAGE_MENU.ACTION_TYPES.onMenuClick),
  }

  return isMenuOpen ? <BackgroundBlocker {...backgroundBlockerProps}/> : null
};
